import { selector, selectorFamily } from 'recoil';

import {
  funeralHomeInfoDataAtomFamily,
  funeralHomeInfoListDataAtom,
  funeralHomeInfoListStatusAtom,
  funeralHomeInfoStatusAtomFamily,
} from './funeralHomeInfo.atom';
import {
  FuneralHomeInfoListState,
  FuneralHomeInfoPopulatedState,
} from './funeralHomeInfo.interface';
export const FuneralHomeInfoListStateSelector = selector<FuneralHomeInfoListState>({
  key: 'funeralHomeInfoListStateSelector',
  get: ({ get }) => {
    return {
      status: get(funeralHomeInfoListStatusAtom),
      data: get(funeralHomeInfoListDataAtom),
    };
  },
});

export const funeralHomeInfoStateSelectorFamily = selectorFamily<
  FuneralHomeInfoPopulatedState,
  string
>({
  key: 'funeralHomeInfoStateSelectorFamily',
  get:
    (id: string) =>
    ({ get }) => {
      return {
        status: get(funeralHomeInfoStatusAtomFamily(id)),
        data: get(funeralHomeInfoDataAtomFamily(id)),
      };
    },
});
